import { ApplicationState } from 'modules/redux-store';

const getState = (state: ApplicationState) => state.pagination;

export const paginationSelector = {
    getState,
};
